import type { FundingInstrument } from "../interfaces/funding";
import type { ICardPaymentMethod } from "../interfaces/payment-method";
import { isCardFundingAvailable } from "./card-funding-availability";

const CARD_PAYMENT_TYPE = "CARD";

export const resolveFundingCardFromInstrument = (
  instrument: FundingInstrument | null,
  registeredCards: readonly ICardPaymentMethod[]
): ICardPaymentMethod | undefined => {
  if (!instrument || instrument.source !== "saved") return undefined;
  return registeredCards.find(
    (c) => c.paymentMethodId === instrument.paymentMethodId
  );
};

type PaymentSlice = {
  type: string;
  cardId?: string | null;
} | null;

export const fundingCardDisplayName = (card: ICardPaymentMethod): string =>
  `${(card.brand || "").toUpperCase()}-${card.last4}`;

export const resolveFundingCardFromState = (
  payment: PaymentSlice,
  instrument: FundingInstrument | null,
  registeredCards: readonly ICardPaymentMethod[]
): ICardPaymentMethod | undefined => {
  const fromInstrument = resolveFundingCardFromInstrument(
    instrument,
    registeredCards
  );
  if (fromInstrument) return fromInstrument;
  const idFromPayment =
    payment?.type === CARD_PAYMENT_TYPE ? payment.cardId ?? undefined : undefined;
  if (!idFromPayment) return undefined;
  return registeredCards.find((c) => c.paymentMethodId === idFromPayment);
};

export const isFundingCardBlocked = (
  card: Pick<ICardPaymentMethod, "fundingMethod">,
  availableFundingMethods: readonly string[]
): boolean => !isCardFundingAvailable(card, availableFundingMethods);
